import type { ESignPackage } from '../types/docmagic';

export const packages: ESignPackage[] = [
  {
    id: 'pkg-1',
    docMagicPackageId: 'DM-902771-PC',
    type: 'Pre-Closing Documents',
    title: 'Closing Disclosure — Pre-Closing',
    rcmLoanNumber: '2026-10482',
    matchMethod: 'RCM Loan Number',
    matchStatus: 'Matched',
    syncStatus: 'OK',
    lastSyncedAt: '2026-09-25T09:12:04',
    pdfStatus: 'Not Ready',
    requireOriginatorCompletion: false,
    participants: [
      {
        sequence: 1,
        name: 'Maria Hernandez',
        email: 'maria.hernandez@gmail.com',
        role: 'Borrower',
        referenceId: 'P-902771-01',
        created: '2026-09-23T14:05:11',
        started: '2026-09-24T19:32:40',
        consented: '2026-09-24T19:33:02',
        viewed: '2026-09-24T19:34:18',
        completed: '2026-09-24T19:52:47',
        declined: null,
      },
      {
        sequence: 2,
        name: 'Daniel Hernandez',
        email: 'dan.hernandez@outlook.com',
        role: 'Borrower',
        referenceId: 'P-902771-02',
        created: '2026-09-23T14:05:11',
        started: '2026-09-25T08:44:09',
        consented: '2026-09-25T08:44:31',
        viewed: '2026-09-25T08:47:55',
        completed: null,
        declined: null,
      },
      {
        sequence: 3,
        name: 'James Whitaker',
        email: 'jwhitaker@rcmlending.com',
        role: 'Originator',
        referenceId: 'P-902771-03',
        created: '2026-09-23T14:05:11',
        started: null,
        consented: null,
        viewed: null,
        completed: null,
        declined: null,
      },
    ],
    documents: [
      { id: 'd1', name: 'Closing Disclosure', pages: 5, status: 'Awaiting Signature' },
      { id: 'd2', name: 'Closing Disclosure Acknowledgment', pages: 1, status: 'Awaiting Signature' },
      { id: 'd3', name: 'Initial Escrow Account Disclosure', pages: 2, status: 'Informational' },
      { id: 'd4', name: 'Notice of Right to Receive Appraisal', pages: 1, status: 'Informational' },
    ],
    receivedDocuments: [],
    emails: [
      { id: 'e1', to: 'maria.hernandez@gmail.com', subject: 'Your closing documents are ready to sign', sentAt: '2026-09-23T14:05:40', status: 'Opened' },
      { id: 'e2', to: 'dan.hernandez@outlook.com', subject: 'Your closing documents are ready to sign', sentAt: '2026-09-23T14:05:41', status: 'Opened' },
      { id: 'e3', to: 'dan.hernandez@outlook.com', subject: 'Reminder: documents awaiting your signature', sentAt: '2026-09-25T08:00:00', status: 'Delivered' },
    ],
    versions: [
      { id: 'v1', version: 1, createdAt: '2026-09-23T14:05:11', createdBy: 'James Whitaker', note: 'Package generated and sent to participants' },
    ],
    logs: [
      { id: 'l1', at: '2026-09-25T09:12:04', direction: 'Outbound', method: 'GET', endpoint: '/v2/packages/DM-902771-PC/participants', status: 200, note: 'Participant activity refreshed (3 participants)' },
      { id: 'l2', at: '2026-09-25T08:47:56', direction: 'Inbound', method: 'POST', endpoint: '/webhooks/docmagic/package-event', status: 201, note: 'Participant viewed event — acknowledged with 201' },
      { id: 'l3', at: '2026-09-24T19:52:48', direction: 'Inbound', method: 'POST', endpoint: '/webhooks/docmagic/package-event', status: 201, note: 'Borrower completed event — 1 of 2 borrowers signed' },
    ],
  },
  {
    id: 'pkg-2',
    docMagicPackageId: 'DM-884213-ID',
    type: 'Initial Disclosures',
    title: 'Initial Disclosures — Loan Estimate',
    rcmLoanNumber: '2026-10482',
    matchMethod: 'RCM Loan Number',
    matchStatus: 'Matched',
    syncStatus: 'OK',
    lastSyncedAt: '2026-09-17T08:14:22',
    pdfStatus: 'Stored',
    pdfFileName: 'Hernandez_InitialDisclosures_Signed_DM-884213.pdf',
    requireOriginatorCompletion: false,
    participants: [
      {
        sequence: 1,
        name: 'Maria Hernandez',
        email: 'maria.hernandez@gmail.com',
        role: 'Borrower',
        referenceId: 'P-884213-01',
        created: '2026-09-16T09:02:15',
        started: '2026-09-16T18:21:03',
        consented: '2026-09-16T18:22:10',
        viewed: '2026-09-16T18:24:36',
        completed: '2026-09-16T18:41:52',
        declined: null,
      },
      {
        sequence: 2,
        name: 'Daniel Hernandez',
        email: 'dan.hernandez@outlook.com',
        role: 'Borrower',
        referenceId: 'P-884213-02',
        created: '2026-09-16T09:02:15',
        started: '2026-09-17T07:55:40',
        consented: '2026-09-17T07:56:02',
        viewed: '2026-09-17T07:58:19',
        completed: '2026-09-17T08:13:45',
        declined: null,
      },
      {
        sequence: 3,
        name: 'James Whitaker',
        email: 'jwhitaker@rcmlending.com',
        role: 'Originator',
        referenceId: 'P-884213-03',
        created: '2026-09-16T09:02:15',
        started: '2026-09-16T09:05:12',
        consented: '2026-09-16T09:05:20',
        viewed: '2026-09-16T09:06:01',
        completed: '2026-09-16T09:10:33',
        declined: null,
      },
    ],
    documents: [
      { id: 'd1', name: 'Loan Estimate', pages: 3, status: 'Signed' },
      { id: 'd2', name: 'Intent to Proceed', pages: 1, status: 'Signed' },
      { id: 'd3', name: 'Uniform Residential Loan Application (1003)', pages: 9, status: 'Signed' },
      { id: 'd4', name: 'eConsent Disclosure', pages: 2, status: 'Informational' },
      { id: 'd5', name: 'Written List of Service Providers', pages: 2, status: 'Informational' },
    ],
    receivedDocuments: [
      { id: 'r1', name: 'Hernandez_InitialDisclosures_Signed_DM-884213.pdf', from: 'DocMagic', receivedAt: '2026-09-17T08:14:20', sizeKb: 2184 },
      { id: 'r2', name: 'Certificate_of_Completion_DM-884213.pdf', from: 'DocMagic', receivedAt: '2026-09-17T08:14:21', sizeKb: 96 },
    ],
    emails: [
      { id: 'e1', to: 'maria.hernandez@gmail.com', subject: 'Your loan disclosures are ready to review and sign', sentAt: '2026-09-16T09:02:40', status: 'Opened' },
      { id: 'e2', to: 'dan.hernandez@outlook.com', subject: 'Your loan disclosures are ready to review and sign', sentAt: '2026-09-16T09:02:41', status: 'Opened' },
      { id: 'e3', to: 'jwhitaker@rcmlending.com', subject: 'All borrowers have signed — DM-884213-ID', sentAt: '2026-09-17T08:14:30', status: 'Delivered' },
    ],
    versions: [
      { id: 'v1', version: 1, createdAt: '2026-09-16T09:02:15', createdBy: 'James Whitaker', note: 'Package generated and sent to participants' },
      { id: 'v2', version: 2, createdAt: '2026-09-17T08:14:20', createdBy: 'DocMagic Integration', note: 'Signed PDF retrieved and attached to loan record' },
    ],
    logs: [
      { id: 'l1', at: '2026-09-17T08:14:22', direction: 'Inbound', method: 'RESPONSE', endpoint: '/webhooks/docmagic/package-event', status: 201, note: 'Processing complete — 201 Created returned to DocMagic' },
      { id: 'l2', at: '2026-09-17T08:14:21', direction: 'Outbound', method: 'POST', endpoint: '/services/data/v60.0/sobjects/ContentVersion', status: 201, note: 'Signed PDF attached to Loan 2026-10482' },
      { id: 'l3', at: '2026-09-17T08:14:19', direction: 'Outbound', method: 'GET', endpoint: '/v2/packages/DM-884213-ID/signed-pdf', status: 200, note: 'Signed package retrieved (2.1 MB)' },
      { id: 'l4', at: '2026-09-17T08:13:46', direction: 'Inbound', method: 'POST', endpoint: '/webhooks/docmagic/package-event', status: 202, note: 'All required borrowers completed — retrieval queued' },
    ],
  },
  {
    id: 'pkg-3',
    docMagicPackageId: 'DM-897640-ID',
    type: 'Initial Disclosures',
    title: 'Revised Loan Estimate — Change of Circumstance',
    rcmLoanNumber: '2026-10482',
    matchMethod: 'RCM Loan Number',
    matchStatus: 'Matched',
    syncStatus: 'OK',
    lastSyncedAt: '2026-09-22T16:31:09',
    pdfStatus: 'Failed',
    pdfError: 'DocMagic returned 504 Gateway Timeout on signed PDF request (3 attempts).',
    requireOriginatorCompletion: false,
    participants: [
      {
        sequence: 1,
        name: 'Maria Hernandez',
        email: 'maria.hernandez@gmail.com',
        role: 'Borrower',
        referenceId: 'P-897640-01',
        created: '2026-09-21T10:15:00',
        started: '2026-09-21T12:02:14',
        consented: '2026-09-21T12:02:30',
        viewed: '2026-09-21T12:03:05',
        completed: '2026-09-21T12:09:47',
        declined: null,
      },
      {
        sequence: 2,
        name: 'Daniel Hernandez',
        email: 'dan.hernandez@outlook.com',
        role: 'Borrower',
        referenceId: 'P-897640-02',
        created: '2026-09-21T10:15:00',
        started: '2026-09-22T16:20:11',
        consented: '2026-09-22T16:20:25',
        viewed: '2026-09-22T16:21:40',
        completed: '2026-09-22T16:30:58',
        declined: null,
      },
      {
        sequence: 3,
        name: 'James Whitaker',
        email: 'jwhitaker@rcmlending.com',
        role: 'Originator',
        referenceId: 'P-897640-03',
        created: '2026-09-21T10:15:00',
        started: '2026-09-21T10:16:02',
        consented: '2026-09-21T10:16:09',
        viewed: null,
        completed: null,
        declined: null,
      },
    ],
    documents: [
      { id: 'd1', name: 'Revised Loan Estimate', pages: 3, status: 'Signed' },
      { id: 'd2', name: 'Change of Circumstance Form', pages: 1, status: 'Signed' },
      { id: 'd3', name: 'Rate Lock Confirmation', pages: 1, status: 'Informational' },
    ],
    receivedDocuments: [],
    emails: [
      { id: 'e1', to: 'maria.hernandez@gmail.com', subject: 'Updated loan estimate ready for signature', sentAt: '2026-09-21T10:15:30', status: 'Opened' },
      { id: 'e2', to: 'dan.hernandez@outlook.com', subject: 'Updated loan estimate ready for signature', sentAt: '2026-09-21T10:15:31', status: 'Opened' },
    ],
    versions: [
      { id: 'v1', version: 1, createdAt: '2026-09-21T10:15:00', createdBy: 'James Whitaker', note: 'Revised package generated after rate lock' },
    ],
    logs: [
      { id: 'l1', at: '2026-09-22T16:31:09', direction: 'Outbound', method: 'GET', endpoint: '/v2/packages/DM-897640-ID/signed-pdf', status: 504, note: 'Signed PDF retrieval failed — retry attempt 3 of 3' },
      { id: 'l2', at: '2026-09-22T16:31:00', direction: 'Inbound', method: 'RESPONSE', endpoint: '/webhooks/docmagic/package-event', status: 201, note: 'Completion event acknowledged; package flagged PDF Pending' },
      { id: 'l3', at: '2026-09-22T16:30:59', direction: 'Inbound', method: 'POST', endpoint: '/webhooks/docmagic/package-event', status: 202, note: 'All required borrowers completed — retrieval queued' },
    ],
  },
  {
    id: 'pkg-4',
    docMagicPackageId: 'DM-903388-CR',
    type: 'Custom Request',
    title: 'Gift Letter — Signature Request',
    rcmLoanNumber: null,
    matchMethod: 'Borrower Email',
    matchStatus: 'Matched',
    matchEmail: 'maria.hernandez@gmail.com',
    syncStatus: 'Failed',
    syncError: 'Unable to reach DocMagic API — connection timed out after 30s.',
    lastSyncedAt: '2026-09-24T11:40:18',
    pdfStatus: 'Not Ready',
    requireOriginatorCompletion: false,
    participants: [
      {
        sequence: 1,
        name: 'Maria Hernandez',
        email: 'maria.hernandez@gmail.com',
        role: 'Borrower',
        referenceId: 'P-903388-01',
        created: '2026-09-24T11:02:00',
        started: '2026-09-24T11:38:44',
        consented: null,
        viewed: null,
        completed: null,
        declined: null,
      },
    ],
    documents: [{ id: 'd1', name: 'Gift Letter', pages: 1, status: 'Awaiting Signature' }],
    receivedDocuments: [],
    emails: [
      { id: 'e1', to: 'maria.hernandez@gmail.com', subject: 'Please sign your gift letter', sentAt: '2026-09-24T11:02:25', status: 'Opened' },
    ],
    versions: [
      { id: 'v1', version: 1, createdAt: '2026-09-24T11:02:00', createdBy: 'Priya Natarajan', note: 'Custom request uploaded to DocMagic' },
    ],
    logs: [
      { id: 'l1', at: '2026-09-25T09:00:31', direction: 'Outbound', method: 'GET', endpoint: '/v2/packages/DM-903388-CR/participants', status: 0, note: 'Connection timed out after 30s — sync failed' },
      { id: 'l2', at: '2026-09-24T11:40:18', direction: 'Outbound', method: 'GET', endpoint: '/v2/packages/DM-903388-CR/participants', status: 200, note: 'Participant activity refreshed (1 participant)' },
      { id: 'l3', at: '2026-09-24T11:02:05', direction: 'Inbound', method: 'RESPONSE', endpoint: '/webhooks/docmagic/package-event', status: 201, note: 'Matched to loan by borrower email maria.hernandez@gmail.com' },
    ],
  },
  {
    id: 'pkg-5',
    docMagicPackageId: 'DM-903512-CR',
    type: 'Custom Request',
    title: 'Letter of Explanation — Credit Inquiries',
    rcmLoanNumber: null,
    matchMethod: 'Borrower Email',
    matchStatus: 'Unmatched',
    matchEmail: 'm.hernandez.homes@yahoo.com',
    syncStatus: 'OK',
    lastSyncedAt: '2026-09-25T09:05:47',
    pdfStatus: 'Not Ready',
    requireOriginatorCompletion: false,
    reviewAlert: {
      assignee: 'Tim Reyes',
      createdAt: '2026-09-25T08:58:12',
      reason: 'No Salesforce borrower found with email m.hernandez.homes@yahoo.com and no loan number on the request.',
    },
    participants: [
      {
        sequence: 1,
        name: 'M. Hernandez',
        email: 'm.hernandez.homes@yahoo.com',
        role: 'Borrower',
        referenceId: 'P-903512-01',
        created: '2026-09-25T08:58:10',
        started: '2026-09-25T09:04:02',
        consented: '2026-09-25T09:04:19',
        viewed: '2026-09-25T09:05:40',
        completed: null,
        declined: null,
      },
    ],
    documents: [{ id: 'd1', name: 'Letter of Explanation — Credit Inquiries', pages: 1, status: 'Awaiting Signature' }],
    receivedDocuments: [],
    emails: [
      { id: 'e1', to: 'm.hernandez.homes@yahoo.com', subject: 'Signature requested: Letter of Explanation', sentAt: '2026-09-25T08:58:30', status: 'Opened' },
    ],
    versions: [
      { id: 'v1', version: 1, createdAt: '2026-09-25T08:58:10', createdBy: 'DocMagic', note: 'Custom request received without loan number' },
    ],
    logs: [
      { id: 'l1', at: '2026-09-25T09:05:47', direction: 'Outbound', method: 'GET', endpoint: '/v2/packages/DM-903512-CR/participants', status: 200, note: 'Participant activity refreshed (1 participant)' },
      { id: 'l2', at: '2026-09-25T08:58:12', direction: 'Outbound', method: 'POST', endpoint: '/services/data/v60.0/sobjects/Task', status: 201, note: 'Manual review alert created for Tim Reyes' },
      { id: 'l3', at: '2026-09-25T08:58:11', direction: 'Inbound', method: 'RESPONSE', endpoint: '/webhooks/docmagic/package-event', status: 201, note: 'No unique borrower match — package retained for manual resolution' },
    ],
  },
];
